import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { confirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { Image } from "primereact/image";
import { InputMask } from "primereact/inputmask";
import { RadioButton } from "primereact/radiobutton";
import "primereact/resources/primereact.css";
import "primereact/resources/themes/saga-blue/theme.css";
import { Toast } from "primereact/toast";
import { classNames } from "primereact/utils";
import React, { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  addDirectorDetails, appendDirectorAddressPermData, appendDirectorAddressTempData, removeDirectorDetails,
  resetDirectorForm, setAuthorizedPerson, setDesignation, setDirectorDocumentListData,
  setDirectorDocumentValue, setDirectorEditById, setDirectorTypeOthers, setDirFirstNameError,
  setFatherFirstName, setFatherFirstNameError, setFatherLastName, setFatherMiddleName, setFirstName,
  setGrandFatherFirstName, setGrandFatherFirstNameError, setGrandFatherLastName, setGrandFatherMiddleName,
  setHasPermanentAddressSame, setLastName, setMiddleName, setPanNo, setSpouseFirstName,
  setSpouseFirstNameError, setSpouseLastName, setSpouseMiddleName, setType, setTypeError,
  setIsContactPerson, setIsDirector, setDesignationOthers, setIsPrimaryContactPerson, setDirDesignationError,
  setPanNoError, setDirCountryError, setDirStateError, setDirMunicipalityError, setDirDistrictError,
  setDirWardError, setDirToleError, setDirEmailIdError, setDirMobileNoError, setDirPerCountryError,
  setDirPerStateError, setDirPerDistrictError, setDirPerMunicipalityError, setDirPerWardError, setDirPerToleError,
  setIsContactPersonError, setIsDirectorError,
} from "../../redux/directorSlice";
import { setDocumentTypeList } from "../../redux/documentSlice";
import AddressInput from "../input/AddressInput";
import ApiBaseURLProps from "../other/apiBaseURL";
import FileUploadComponent from "../other/fileUploadComponent";
import InputText from "../other/InputText";
import Label from "../other/label";
import ApiService from "../service/apiService";
import LookupService from "../service/lookupService";
import { SaveButton } from "./declerationDetails";
import { DocumentUpload } from "./documentDetails";
import { NextButton, PrevButton } from "./kycSidebar";
import { setDesignationList } from "../../redux/lookupSlice";
import { Dropdown } from "primereact/dropdown";
import { getTValue } from "../other/label";


const contactPersonList = [{
  code: true,
  descEng: "Primary Contact Person"
}, {
  code: false,
  descEng: "Secondary Contact Person"
}]
const footer = () => (
  <div className="p-grid" style={{ flex: 3, padding: "0 10px" }}>
    <div style={{ flex: 1 }}>
      <PrevButton />
    </div>
    <div style={{ flex: 1 }}>
      <center>
        <SaveButton style={{ flex: 1 }} />
      </center>
    </div>
    <div style={{ flex: 1 }}>
      <center>
        <NextButton />
      </center>
    </div>
  </div>
);

function DirectorDetails() {
  const { t, i18n } = useTranslation();
  const directorDetails = useSelector((state) => state.directorDetails);
  const hasPermanentAddressSame = useSelector((state) => state.directorDetails.hasPermanentAddressSame);
  const directorId = useSelector((state) => state.directorDetails.directorId);
  const type = useSelector((state) => state.directorDetails.type);
  const firstName = useSelector((state) => state.directorDetails.firstName);
  const middleName = useSelector((state) => state.directorDetails.middleName);
  const lastName = useSelector((state) => state.directorDetails.lastName);
  const designation = useSelector((state) => state.directorDetails.designation);
  const designationOthers = useSelector((state) => state.directorDetails.designationOthers);
  const isContactPerson = useSelector((state) => state.directorDetails.isContactPerson);
  const isDirector = useSelector((state) => state.directorDetails.isDirector);
  const isPrimaryContactPerson = useSelector((state) => state.directorDetails.isPrimaryContactPerson);
  const spouseFirstName = useSelector(
    (state) => state.directorDetails.spouseFirstName
  );
  const spouseMiddleName = useSelector(
    (state) => state.directorDetails.spouseMiddleName
  );
  const spouseLastName = useSelector(
    (state) => state.directorDetails.spouseLastName
  );
  const fatherFirstName = useSelector(
    (state) => state.directorDetails.fatherFirstName
  );
  const fatherMiddleName = useSelector(
    (state) => state.directorDetails.fatherMiddleName
  );
  const fatherLastName = useSelector(
    (state) => state.directorDetails.fatherLastName
  );
  const grandFatherFirstName = useSelector(
    (state) => state.directorDetails.grandFatherFirstName
  );
  const grandFatherMiddleName = useSelector(
    (state) => state.directorDetails.grandFatherMiddleName
  );
  const grandFatherLastName = useSelector(
    (state) => state.directorDetails.grandFatherLastName
  );
  const panNo = useSelector((state) => state.directorDetails.panNo);
  const signature = useSelector((state) => state.directorDetails.signature);
  const authorizedPerson = useSelector(
    (state) => state.directorDetails.authorizedPerson
  );
  const directorTypeOthers = useSelector(
    (state) => state.directorDetails.directorTypeOthers
  );
  const directorDetailsList =
    useSelector((state) => state.directorDetails.directorDetailsList) || [];
  const [status, setStatus] = useState(false);
  const [rowIndex, setRowIndex] = useState({});
  const [rowData, setRowData] = useState({});
  const [directorTypeList, setDirectorTypeList] = useState([]);

  const dispatch = useDispatch();
  const toast = useRef(null);

  const errorObj = useSelector((state) => state.directorDetails.errors);
  let {
    typeError,
    firstNameError,
    lastNameError,
    designationError,
    spouseFirstNameError,
    spouseLastNameError,
    fatherFirstNameError,
    fatherLastNameError,
    grandFatherFirstNameError,
    grandFatherLastNameError,
    panNoError,
    dirError,
    isDirectorError,
    isContactPersonError,
  } = {};

  if (errorObj && errorObj.typeError) {
    typeError = errorObj.typeError.message;
  }
  if (errorObj && errorObj.dirError) {
    dirError = errorObj.dirError.message;
  }
  if (errorObj && errorObj.firstNameError) {
    firstNameError = errorObj.firstNameError.message;
  }
  if (errorObj && errorObj.lastNameError) {
    lastNameError = errorObj.lastNameError.message;
  }
  if (errorObj && errorObj.designationError) {
    designationError = errorObj.designationError.message;
  }
  if (errorObj && errorObj.spouseFirstNameError) {
    spouseFirstNameError = errorObj.spouseFirstNameError.message;
  }
  if (errorObj && errorObj.spouseLastNameError) {
    spouseLastNameError = errorObj.spouseLastNameError.message;
  }
  if (errorObj && errorObj.fatherFirstNameError) {
    fatherFirstNameError = errorObj.fatherFirstNameError.message;
  }
  if (errorObj && errorObj.fatherLastNameError) {
    fatherLastNameError = errorObj.fatherLastNameError.message;
  }
  if (errorObj && errorObj.grandFatherFirstNameError) {
    grandFatherFirstNameError = errorObj.grandFatherFirstNameError.message;
  }
  if (errorObj && errorObj.grandFatherLastNameError) {
    grandFatherLastNameError = errorObj.grandFatherLastNameError.message;
  }
  if (errorObj && errorObj.panNoError) {
    panNoError = errorObj.panNoError.message;
  }
  if (errorObj && errorObj.isContactPersonError) {
    isContactPersonError = errorObj.isContactPersonError.message;
  }
  if (errorObj && errorObj.isDirectorError) {
    isDirectorError = errorObj.isDirectorError.message;
  }

  const ldirectorTypeList = useSelector(
    (state) => state.lookupDetails.directorTypeList
  );
  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({});
  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  useEffect(() => {
    ApiService.getDirectorTypeList().then((response) => {
      console.log(response.data);
      setDirectorTypeList(response.data.data);
      console.log(directorTypeList);
    });
    if (!ldirectorTypeList) {
      LookupService.getDirectorTypeList(dispatch);
    }
  }, []);

  const toogleStatus = (status) => {
    setStatus((prevCheck) => !prevCheck);
  };

  const documentTypeList = useSelector(
    (state) => state.documentDetails.documentTypeList
  );
  const documentType = documentTypeList.find((d) => d.code === "PH") || {};

  const directorDocumentList = useSelector(
    (state) => state.directorDetails.directorDocumentList
  );

  const designationList = useSelector(
    (state) => state.lookupDetails.designationList
  );

  useEffect(() => {
    if (!documentTypeList.length)
      ApiService.getDocumentTypeList().then((response) => {
        console.log("doc", response);
        dispatch(setDocumentTypeList(response.data.data));
      });

    ApiService.getDesignationList().then((response) => {
      dispatch(setDesignationList(response.data.data));
    })
  }, []);

  const photo =
    directorDocumentList.find((d) => d.documentTypeId === "PH") || {};

  const displayConfirmModal = (rowData) => {
    confirmDialog({
      message: "Are you sure you want to proceed?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () =>
        dispatch(removeDirectorDetails(rowData.id || rowData.tempId)),
    });
  };

  const [formError, setFormError] = useState({});

  const validateContactPerson = (hasError) => {
    if (!firstName || !lastName) {
      hasError = true;
      dispatch(
        setDirFirstNameError({
          message: "Name is required",
          section: "DD",
        })
      );
    }
    if (!designation) {
      hasError = true;
      dispatch(
        setDirDesignationError({
          message: "Designation is required",
          section: "DD",
        })
      );
    }
    if (!fatherFirstName || !fatherLastName) {
      hasError = true;
      dispatch(
        setFatherFirstNameError({
          message: "Father Name is required",
          section: "DD",
        })
      );
    } else if (!checkName(fatherFirstName, fatherLastName)) {
      hasError = true;
      dispatch(
        setFatherFirstNameError({
          message: "Father Name is not valid",
          section: "DD",
        })
      );
    }

    if (!grandFatherFirstName || !grandFatherLastName) {
      hasError = true;
      dispatch(
        setGrandFatherFirstNameError({
          message: "Grand Father Name is required",
          section: "DD",
        })
      );
    } else if (
      !checkName(grandFatherFirstName, grandFatherLastName)
    ) {
      hasError = true;
      dispatch(
        setGrandFatherFirstNameError({
          message: "Grand Father Name is not valid",
          section: "DD",
        })
      );
    }

    if (!checkName(spouseFirstName, spouseLastName)) {
      hasError = true;
      dispatch(
        setSpouseFirstNameError({
          message: "Spouse Name is not valid",
          section: "DD",
        })
      );
    }
    return hasError;
  }

  const validateContactPersonAddress = (hasError) => {
    if (!directorDetails.emailId) {
      hasError = true;
      dispatch(
        setDirEmailIdError({
          message: "Email is required",
          section: "DD",
        })
      );
    }
    if (!directorDetails.mobileNo) {
      hasError = true;
      dispatch(
        setDirMobileNoError({
          message: "Mobile Number is required",
          section: "DD",
        })
      );
    }
    return hasError;
  }

  const validateIsDirectorDetails = () => {
    let hasError = false;
    validateContactPerson(hasError);
    if (!panNo) {
      hasError = true;
      dispatch(
        setPanNoError({
          message: "Pan Number is required",
          section: "DD",
        })
      );
    }

    if (!directorDetails.country) {
      hasError = true;
      dispatch(
        setDirCountryError({
          message: "Country is required",
          section: "DD",
        })
      );
    }

    if (!directorDetails.perCountry) {
      hasError = true;
      dispatch(
        setDirPerCountryError({
          message: "Country is required",
          section: "DD",
        })
      );
    }

    if (directorDetails.country === "NP") {
      if (!directorDetails.state) {
        hasError = true;
        dispatch(
          setDirStateError({
            message: "State is required",
            section: "DD",
          })
        );
      }
      if (!directorDetails.district) {
        hasError = true;
        dispatch(
          setDirDistrictError({
            message: "District is required",
            section: "DD",
          })
        );
      }
      if (!directorDetails.municipality) {
        hasError = true;
        dispatch(
          setDirMunicipalityError({
            message: "Municipality is required",
            section: "DD",
          })
        );
      }
      if (!directorDetails.ward) {
        hasError = true;
        dispatch(
          setDirWardError({
            message: "Ward is required",
            section: "DD",
          })
        );
      }

      if (!directorDetails.perCountry) {
        hasError = true;
        dispatch(
          setDirPerCountryError({
            message: "Country is required",
            section: "DD",
          })
        );
      }
      if (!directorDetails.perState) {
        hasError = true;
        dispatch(
          setDirPerStateError({
            message: "State is required",
            section: "DD",
          })
        );
      }
      if (!directorDetails.perDistrict) {
        hasError = true;
        dispatch(
          setDirPerDistrictError({
            message: "District is required",
            section: "DD",
          })
        );
      }
      if (!directorDetails.perMunicipality) {
        hasError = true;
        dispatch(
          setDirPerMunicipalityError({
            message: "Municipality is required",
            section: "DD",
          })
        );
      }
      if (!directorDetails.perWard) {
        hasError = true;
        dispatch(
          setDirPerWardError({
            message: "Ward Number is required",
            section: "DD",
          })
        );
      }
    }

    if (!directorDetails.tole) {
      hasError = true;
      dispatch(
        setDirToleError({
          message: "Tole is required",
          section: "DD",
        })
      );
    }
    if (!directorDetails.emailId) {
      hasError = true;
      dispatch(
        setDirEmailIdError({
          message: "Email is required",
          section: "DD",
        })
      );
    }
    if (!directorDetails.mobileNo) {
      hasError = true;
      dispatch(
        setDirMobileNoError({
          message: "Mobile Number is required",
          section: "DD",
        })
      );
    }

    if (!directorDetails.perTole) {
      hasError = true;
      dispatch(
        setDirPerToleError({
          message: "Tole is required",
          section: "DD",
        })
      );
    }
    return hasError;
  }



  return (
    <Card
      className="p-col-12 p-md-12 main-card"
      header={
        <h3 className="p-col-12 p-md-12 text-center">
          <i className="pi pi-user" />
          {t("directorDetails")}
        </h3>
      }
      footer={footer}
    >
      <Toast ref={toast} />
      <div className="p-grid p-fluid">
        <div
          className="p-field p-col-12 p-md-12"
        >
          <FileUploadComponent
            type="userPhoto"
            data={{ ...photo, ...documentType }}
            onUpload={(data) => {
              dispatch(
                setDirectorDocumentValue({
                  code: "PH",
                  key: "fileId",
                  value: data.storageFileName,
                })
              );
            }}
          />
        </div>
        {/* <div className="p-field p-col-12 p-md-12">
          <label className="p-col-12 p-md-12" htmlFor="type">
            {t("type")}*
          </label>
          <div
            id="directorForm"
            className="p-field-radiobutton p-col-12 p-md-12"
          >
            {directorTypeList.map((types) => (
              <div key={types.code}>
                <label>
                  <Controller
                    name="type"
                    control={control}
                    rules={{ required: "Type is required." }}
                    render={({ field, fieldState }) => (
                      <RadioButton
                        id={field.name}
                        {...field}
                        value={types.code}
                        onChange={(e) => {
                          dispatch(setType(e.value));
                          if (e.value !== "O") {
                            dispatch(setDirectorTypeOthers(null));
                          }
                        }}
                        checked={type === types.code}
                        className={
                          (classNames({ "p-invalid": fieldState.invalid }),
                            "p-ml-2 p-mr-2")
                        }
                      />
                    )}
                  />
                  <Label text={types.descEng} textNep={types.descNep} />
                </label>
              </div>
            ))}
          </div>
          <span style={{ color: "red" }}>{typeError}</span>
        </div>
        {getFormErrorMessage("type")}
        {type === "O" ? (
          <>
            <div className="p-field p-col-12 p-md-4 stick-left">
              <label className="p-col-12 p-md-12" htmlFor="directorType">
                {t("directorTypeOthers")}
              </label>
              <div className="p-inputgroup">
                <InputText
                  clearSpace
                  value={directorTypeOthers}
                  onChange={(e) => {
                    dispatch(setDirectorTypeOthers(e.target.value));
                  }}
                  placeholder={t("directorTypeOthers")}
                />
              </div>
            </div>
          </>
        ) : null} */}
        <div
          id="directorForm"
          className=" p-col-12 p-md-12"
        ></div>
        <div className="p-field p-col-12 p-md-12">
          <label className="p-col-12 p-md-12" htmlFor="name">
            {t("nameSurname")}*
          </label>
          <div className="p-inputgroup">
            <Controller
              name="firstName"
              control={control}
              rules={{ required: "First Name is required." }}
              render={({ field, fieldState }) => (
                <InputText
                  isName
                  id={field.name}
                  {...field}
                  keyfilter="alpha"
                  placeholder={t("fName")}
                  onChange={(e) => dispatch(setFirstName(e.target.value))}
                  value={firstName}
                  className={classNames({ "p-invalid": fieldState.invalid })}
                />
              )}
            />
            <Controller
              name="middleName"
              control={control}
              rules={{ required: "Middle Name is required." }}
              render={({ field, fieldState }) => (
                <InputText
                  isName
                  id={field.name}
                  {...field}
                  placeholder={t("mName")}
                  keyfilter={/^[a-zA-Z ]*$/}
                  onChange={(e) => dispatch(setMiddleName(e.target.value))}
                  value={middleName}
                  className={classNames({ "p-invalid": fieldState.invalid })}
                />
              )}
            />
            <Controller
              name="lastName"
              control={control}
              rules={{ required: "Last Name is required." }}
              render={({ field, fieldState }) => (
                <InputText
                  isName
                  id={field.name}
                  {...field}
                  keyfilter={/^[a-zA-Z .]*$/}
                  placeholder={t("lName")}
                  onChange={(e) => dispatch(setLastName(e.target.value))}
                  value={lastName}
                  className={classNames({ "p-invalid": fieldState.invalid })}
                />
              )}
            />
          </div>
          <span style={{ color: "red" }}>{firstNameError}</span>
        </div>
        {getFormErrorMessage("firstName")}
        {getFormErrorMessage("middleName")}
        {getFormErrorMessage("lastName")}
        <div className="p-field p-col-12 p-md-6 stick-right">
          <label className="p-col-12 p-md-12" htmlFor="designation">
            {t("designation")}*
          </label>
          <Controller
            name="designation"
            control={control}
            rules={{ required: "Designation is required." }}
            render={({ field, fieldState }) => (
              <Dropdown
                id={field.id}
                value={designation}
                filter showClear
                onChange={(e) => {
                  field.onChange(e.value);
                  dispatch(setDesignation(e.value));
                  if (e.value !== "O")
                    dispatch(setDesignationOthers(""));
                }}
                options={designationList}
                optionLabel={(data) =>
                  getTValue(i18n, data.descEng, data.descNep)
                }
                placeholder={t("selectDesignation")}
                optionValue="code"
              />
            )}
          />
          <span style={{ color: "red" }}>{designationError}</span>
        </div>
        {designation === "O" ? (
          <>
            <div className="p-field p-col-12 p-md-6 stick-left">
              <label className="p-col-12 p-md-12" htmlFor="designationOthers">
                {t("designationOthers")}
              </label>
              <div className="p-inputgroup">
                <InputText
                  clearSpace
                  value={designationOthers}
                  onChange={(e) => {
                    dispatch(setDesignationOthers(e.target.value));
                  }}
                  placeholder={t("designationOthers")}
                />
              </div>
            </div>
          </>
        ) : null}
        <div className="p-field p-col-12 p-md-6 stick-left">
          <label className="p-col-12 p-md-12" htmlFor="panNo">
            {t("panNo")}
          </label>
          <div className="p-inputgroup">
            <Controller
              name="panNo"
              control={control}
              rules={{ required: "Pan Number is required." }}
              render={({ field, fieldState }) => (
                <InputMask
                  mask="999999999"
                  id={field.name}
                  {...field}
                  placeholder={t("panNo")}
                  onChange={(e) => dispatch(setPanNo(e.target.value))}
                  value={panNo}
                  className={classNames({ "p-invalid": fieldState.invalid })}
                />
              )}
            />
          </div>
          <span style={{ color: "red" }}>{panNoError}</span>
        </div>
        {getFormErrorMessage("panNo")}

        <div className="p-field p-col-12 p-md-3">
          <label className="p-col-12 p-md-12" htmlFor="isContactPerson">
            {t("isContactPerson")}?*
          </label>
          <Controller name="isContactPerson"
            control={control} rules={{ required: true }}
            render={({ field, fieldState }) => (
              <Checkbox inputId={field.name} onChange={(e) => {
                field.onChange(e.checked);
                dispatch(setIsContactPerson(e.checked))
              }}
                checked={isContactPerson} className={classNames({ 'p-invalid': fieldState.invalid })} />
            )}
          />
          <span style={{ color: "red" }}>{isContactPersonError}</span>
        </div>

        <div className="p-field p-col-12 p-md-3">
          <label className="p-col-12 p-md-12" htmlFor="isDirector">
            {t("isDirector")}?*
          </label>
          <Controller name="isDirector"
            control={control}
            rules={{ required: true }}
            render={({ field, fieldState }) => (
              <Checkbox inputId={field.name} onChange={(e) => {
                field.onChange(e.checked);
                dispatch(setIsDirector(e.checked))
              }}
                checked={isDirector} className={classNames({ 'p-invalid': fieldState.invalid })} />
            )}
          />
          <span style={{ color: "red" }}>{isDirectorError}</span>
        </div>

        {isContactPerson &&
          <div className="p-field p-col-12 p-md-6 stick-left">
            <label className="p-col-12 p-md-12" htmlFor="contactPerson">
              {t("contactPerson")}*
            </label>
            <Controller
              name="contactPerson"
              control={control}
              rules={{ required: "Contact Person is required." }}
              render={({ field, fieldState }) => (
                <Dropdown
                  id={field.id}
                  value={isPrimaryContactPerson}
                  filter showClear
                  onChange={(e) => {
                    field.onChange(e.value);
                    dispatch(setIsPrimaryContactPerson(e.value));
                  }}
                  options={contactPersonList}
                  optionLabel={(data) =>
                    getTValue(i18n, data.descEng, data.descNep)
                  }
                  placeholder={t("selectContactPerson")}
                  optionValue="code"
                />
              )}
            />
          </div>
        }





        {/* <div className="p-field p-col-12 p-md-6 stick-right">
          <label className="p-col-12 p-md-12" htmlFor="designation">
            {t("designation")}*
          </label>
          <div className="p-inputgroup">
            <Controller
              name="designation"
              control={control}
              rules={{ required: "Designation is required." }}
              render={({ field, fieldState }) => (
                <InputText
                  id={field.name}
                  {...field}
                  keyfilter={/^[a-zA-Z0-9\-\.\,\/\(\) ]$/}
                  clearSpace
                  placeholder={t("designation")}
                  onChange={(e) => dispatch(setDesignation(e.target.value))}
                  value={designation}
                  className={classNames({ "p-invalid": fieldState.invalid })}
                />
              )}
            />
          </div>
          <span style={{ color: "red" }}>{designationError}</span>
        </div>
        {getFormErrorMessage("designation")} */}

        <div className="p-field p-col-12 p-md-12">
          <label className="p-col-12 p-md-12" htmlFor="secretaryName">
            {t("spouseName")}
          </label>
          <div className="p-inputgroup">
            <Controller
              name="spouseFirstName"
              control={control}
              rules={{ required: "Spouse First Name is required." }}
              render={({ field, fieldState }) => (
                <InputText
                  isName
                  id={field.name}
                  {...field}
                  keyfilter="alpha"
                  placeholder={t("fName")}
                  onChange={(e) => dispatch(setSpouseFirstName(e.target.value))}
                  value={spouseFirstName}
                  className={classNames({ "p-invalid": fieldState.invalid })}
                />
              )}
            />
            <Controller
              name="spouseMiddleName"
              control={control}
              rules={{ required: "Spouse Middle Name is required." }}
              render={({ field, fieldState }) => (
                <InputText
                  isName
                  id={field.name}
                  {...field}
                  placeholder={t("mName")}
                  keyfilter={/^[a-zA-Z ]*$/}
                  onChange={(e) =>
                    dispatch(setSpouseMiddleName(e.target.value))
                  }
                  value={spouseMiddleName}
                  className={classNames({ "p-invalid": fieldState.invalid })}
                />
              )}
            />
            <Controller
              name="spouseLastName"
              control={control}
              rules={{ required: "Spouse Last Name is required." }}
              render={({ field, fieldState }) => (
                <InputText
                  isName
                  id={field.name}
                  {...field}
                  keyfilter={/^[a-zA-Z .]*$/}
                  placeholder={t("lName")}
                  onChange={(e) => dispatch(setSpouseLastName(e.target.value))}
                  value={spouseLastName}
                  className={classNames({ "p-invalid": fieldState.invalid })}
                />
              )}
            />
          </div>
          <span style={{ color: "red" }}>{spouseFirstNameError}</span>
        </div>
        {getFormErrorMessage("spouseFirstName")}
        {getFormErrorMessage("spouseMiddleName")}
        {getFormErrorMessage("spouseLastName")}
        <div className="p-field p-col-12 p-md-12">
          <label className="p-col-12 p-md-12" htmlFor="secretaryName">
            {t("fatherName")}*
          </label>
          <div className="p-inputgroup">
            <Controller
              name="fatherFirstName"
              control={control}
              rules={{ required: "Father First Name is required." }}
              render={({ field, fieldState }) => (
                <InputText
                  id={field.name}
                  {...field}
                  isName
                  keyfilter="alpha"
                  placeholder={t("fName")}
                  onChange={(e) => dispatch(setFatherFirstName(e.target.value))}
                  value={fatherFirstName}
                  className={classNames({ "p-invalid": fieldState.invalid })}
                />
              )}
            />
            <Controller
              name="fatherMiddleName"
              control={control}
              rules={{ required: "Father Middle Name is required." }}
              render={({ field, fieldState }) => (
                <InputText
                  id={field.name}
                  {...field}
                  isName
                  placeholder={t("mName")}
                  keyfilter={/^[a-zA-Z ]*$/}
                  onChange={(e) =>
                    dispatch(setFatherMiddleName(e.target.value))
                  }
                  value={fatherMiddleName}
                  className={classNames({ "p-invalid": fieldState.invalid })}
                />
              )}
            />
            <Controller
              name="fatherLastName"
              control={control}
              rules={{ required: "Father Last Name is required." }}
              render={({ field, fieldState }) => (
                <InputText
                  isName
                  id={field.name}
                  {...field}
                  keyfilter={/^[a-zA-Z .]*$/}
                  placeholder={t("lName")}
                  onChange={(e) => dispatch(setFatherLastName(e.target.value))}
                  value={fatherLastName}
                  className={classNames({ "p-invalid": fieldState.invalid })}
                />
              )}
            />
          </div>
          <span style={{ color: "red" }}>{fatherFirstNameError}</span>
        </div>
        {getFormErrorMessage("fatherFirstName")}
        {getFormErrorMessage("fatherMiddleName")}
        {getFormErrorMessage("fatherLastName")}
        <div className="p-field p-col-12 p-md-12">
          <label className="p-col-12 p-md-12" htmlFor="secretaryName">
            {t("grandFatherName")}*
          </label>
          <div className="p-inputgroup">
            <Controller
              name="grandFatherFirstName"
              control={control}
              rules={{ required: "Grand Father First Name is required." }}
              render={({ field, fieldState }) => (
                <InputText
                  isName
                  id={field.name}
                  {...field}
                  keyfilter="alpha"
                  placeholder={t("fName")}
                  onChange={(e) =>
                    dispatch(setGrandFatherFirstName(e.target.value))
                  }
                  value={grandFatherFirstName}
                  className={classNames({ "p-invalid": fieldState.invalid })}
                />
              )}
            />
            <Controller
              name="grandFatherMiddleName"
              control={control}
              rules={{ required: "Grand Father Middle Name is required." }}
              render={({ field, fieldState }) => (
                <InputText
                  isName
                  id={field.name}
                  {...field}
                  placeholder={t("mName")}
                  keyfilter={/^[a-zA-Z ]*$/}
                  onChange={(e) =>
                    dispatch(setGrandFatherMiddleName(e.target.value))
                  }
                  value={grandFatherMiddleName}
                  className={classNames({ "p-invalid": fieldState.invalid })}
                />
              )}
            />
            <Controller
              name="grandFatherLastName"
              control={control}
              rules={{ required: "Grand Father Last Name is required." }}
              render={({ field, fieldState }) => (
                <InputText
                  isName
                  id={field.name}
                  {...field}
                  keyfilter={/^[a-zA-Z .]*$/}
                  placeholder={t("lName")}
                  onChange={(e) =>
                    dispatch(setGrandFatherLastName(e.target.value))
                  }
                  value={grandFatherLastName}
                  className={classNames({ "p-invalid": fieldState.invalid })}
                />
              )}
            />
          </div>
          <span style={{ color: "red" }}>{grandFatherFirstNameError}</span>
        </div>
        {getFormErrorMessage("grandFatherFirstName")}
        {getFormErrorMessage("grandFatherMiddleName")}
        {getFormErrorMessage("grandFatherLastName")}
      </div>
      <h4 className=" p-col-12 p-md-12">
        <p className="section-title ">{t("currentAddress")}</p>
      </h4>
      <AddressInput
        errorObj={errorObj}
        hide={{ website: true, fax: true }}
        data={directorDetails}
        onChange={data => {
          dispatch(appendDirectorAddressTempData(data));
        }} />

      <h4 className=" p-col-12 p-md-12">
        <p className="section-title ">{t("permanentAddress")}</p>
      </h4>
      <div className="p-field p-col-12 p-md-12">
        <label className="p-col-12 p-md-12" style={{ textAlign: "center" }}>
          {t("isPermanentAddressSame")}*
        </label>
        <div
          className="p-field-radiobutton p-col-12"
          style={{ justifyContent: "center" }}
        >
          <Controller
            name="hasPermanentAddressSame"
            control={control}
            rules={{ required: "Address is required." }}
            render={({ field, fieldState }) => (
              <RadioButton
                id={field.name}
                {...field}
                value={true}
                onChange={(e) =>
                  dispatch(setHasPermanentAddressSame(e.value))
                }
                checked={hasPermanentAddressSame === true}
                className={classNames({
                  "p-invalid": fieldState.invalid,
                })}
              />
            )}
          />
          <label style={{ marginRight: "10px" }}>{t("yes")}</label>
          <Controller
            name="hasPermanentAddressSame"
            control={control}
            rules={{ required: "Address is required." }}
            render={({ field, fieldState }) => (
              <RadioButton
                id={field.name}
                {...field}
                value={false}
                onChange={(e) =>
                  dispatch(setHasPermanentAddressSame(e.value))
                }
                checked={hasPermanentAddressSame === false}
                className={classNames({
                  "p-invalid": fieldState.invalid,
                })}
              />
            )}
          />
          <label>{t("no")}</label>
        </div>
      </div>
      {getFormErrorMessage("hasPermanentAddressSame")}
      <AddressInput
        errorObj={errorObj}
        hide={{ website: true, emailId: true, mobileNo: true, fax: true }}
        data={directorDetails}
        disabled={hasPermanentAddressSame}
        prefix="per"
        onChange={data => {
          dispatch(appendDirectorAddressPermData(data));
        }} />
      <div className="p-grid p-fluid">
        <h4 className="p-col-12 p-md-12">
          <p className="section-title">{t("documentUpload")}</p>
        </h4>
        {directorDocumentList
          .filter((p) => p.documentTypeId !== "PH")
          .map((p) => (
            <DocumentUpload
              document={p}
              onUpload={(data) => {
                dispatch(
                  setDirectorDocumentValue({
                    code: p.documentTypeId,
                    key: "fileId",
                    value: data.storageFileName,
                  })
                );
                dispatch(
                  setDirectorDocumentValue({
                    code: p.documentTypeId,
                    key: "fileName",
                    value: data.originalName,
                  })
                );
              }}
              onUploadBack={(data) => {
                dispatch(
                  setDirectorDocumentValue({
                    code: p.documentTypeId,
                    key: "backFileId",
                    value: data.storageFileName,
                  })
                );
                dispatch(
                  setDirectorDocumentValue({
                    code: p.documentTypeId,
                    key: "backFileName",
                    value: data.originalName,
                  })
                );
              }}
            />
          ))}
      </div>
      <div className="p-grid p-fluid">
        {/* <div className="p-field p-col-12 p-md-12">
                    <label className="p-col-12 p-md-6">{t("signature")}</label>
                    <Input type="file" placeholder="Signature" />
                </div>
                <div className="p-field p-col-12 p-md-12">
                    <label className="p-col-12 p-md-6">{t("photo")}</label>
                    <Input type="file" placeholder="Photo" />
                </div> */}
        {/* <div className="p-field p-col-12 p-md-6 stick-right">
          <label className="p-col-12 p-md-12" htmlFor="authorizedPerson">
            {t("isAuthorizedPerson")}
          </label>
          <div className="p-grid p-col-12">
            <div className="p-field-radiobutton p-col-12 p-md-4 ">
              <Controller
                name="authorizedPerson"
                control={control}
                rules={{ required: "Authorized Person is required." }}
                render={({ field, fieldState }) => (
                  <RadioButton
                    id={field.name}
                    {...field}
                    
                    value={"Y"}
                    onChange={(e) => dispatch(setAuthorizedPerson(e.value))}
                    checked={authorizedPerson === "Y"}
                    className={classNames({ "p-invalid": fieldState.invalid })}
                  />
                )}
              />
              <label htmlFor="ceo">{t("yes")}</label>
            </div>
            <div className="p-field-radiobutton p-col-12 p-md-4 ">
              <Controller
                name="authorizedPerson"
                control={control}
                rules={{ required: "Type is required." }}
                render={({ field, fieldState }) => (
                  <RadioButton
                    id={field.name}
                    {...field}
                    
                    value={"N"}
                    onChange={(e) => dispatch(setAuthorizedPerson(e.value))}
                    checked={authorizedPerson === "N"}
                    className={classNames({ "p-invalid": fieldState.invalid })}
                  />
                )}
              />
              <label htmlFor="directors">{t("no")}</label>
            </div>
          </div> */}
        {/* </div> */}
        <div className="p-col-12 p-md-12">
          <div className="p-grid">
            <div className="p-col-12 p-md-8"></div>
            <div className="p-col-12 p-md-2">
              <Button
                className=" p-button-secondary submit-button"
                onClick={(e) => {
                  dispatch(resetDirectorForm(""));
                }}
                style={{
                  textAlign: "center",
                  borderRadius: "19px",
                  width: "125px",
                }}
                label="Clear Form"
              ></Button>
            </div>
            <div className="p-col-12 p-md-2">
              <Button
                onClick={(e) => {
                  let hasError = false;
                  if (!firstName || !lastName) {
                    hasError = true;
                    dispatch(
                      setDirFirstNameError({
                        message: "Name is required",
                        section: "DD",
                      })
                    );
                  }

                  if (!designation) {
                    hasError = true;
                    dispatch(
                      setDirDesignationError({
                        message: "Designation is required",
                        section: "DD",
                      })
                    );
                  }

                  if (isDirector) {
                    hasError = hasError || validateIsDirectorDetails();
                  }

                  if (isContactPerson) {
                    const cFlag = validateContactPerson(false);
                    const aFlag = validateContactPersonAddress(false);
                    hasError = hasError || cFlag || aFlag;
                  }

                  if (hasError) {
                    document.getElementById("directorForm").scrollIntoView();
                  } else {
                    dispatch(addDirectorDetails());
                    dispatch(resetDirectorForm());
                  }
                }}
                style={{ textAlign: "center", borderRadius: "19px" }}
                label={directorId ? "Update" : "Add New"}
              ></Button>
            </div>
          </div>
          <span style={{ color: "red" }}>{dirError}</span>
          <DataTable value={directorDetailsList}
            style={{ minWidth: 300 }}
            dataKey="director">
            {/* <Column
              body={(rowData) => {
                return (
                  (ldirectorTypeList &&
                    ldirectorTypeList.find((p) => p.code == rowData.type)) ||
                  {}
                ).descEng;
              }}
              header={t("type")}
            ></Column> */}
            <Column
              body={(rowData, index) =>
                rowData.firstName +
                " " +
                (rowData.middleName ? rowData.middleName + " " : "") +
                rowData.lastName
              }
              header={t("nameSurname")}
            ></Column>
            <Column body={(rowData, index) => {
              return ((designationList && designationList.find((p) => p.code == rowData.designation)) || {}).descEng;

            }
            } header={t("designation")}></Column>
            <Column
              header={t("isAuthorizedPerson")}
              body={(rowData, index) => (
                <Checkbox
                  name="authorizedPerson"
                  checked={rowData.authorizedPerson}
                  onChange={(e) => {
                    console.log("row", rowData);
                    dispatch(setAuthorizedPerson(rowData.id || rowData.tempId));
                  }}
                />
              )}
            ></Column>
            <Column
              header={t("action")}
              body={(rowData, index) => {
                return (
                  <>
                    <i
                      className="pi pi-pencil"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        dispatch(resetDirectorForm());

                        dispatch(
                          setDirectorEditById(rowData.id || rowData.tempId)
                        );

                        dispatch(
                          setDirectorDocumentListData(rowData.documentList)
                        );
                      }}
                    />
                    &nbsp;&nbsp;
                    <i
                      className="pi pi-trash"
                      style={{ cursor: "pointer" }}
                      onClick={
                        () => {
                          displayConfirmModal(rowData);
                        }
                        // dispatch(
                        //   removeDirectorDetails(rowData.id || rowData.tempId)
                        // )
                      }
                    />
                  </>
                );
              }}
            ></Column>
          </DataTable>
          {/* {status ? <EditDirectorDetails rowIndex={rowIndex} /> : ""} */}
        </div>
      </div>
    </Card>
  );
}

const checkName = (f, l) => {
  return (!f && !l) || (f && l);
};

export default DirectorDetails;
